import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import DownloadWindowsContent from './DownloadWindowsContent';

interface DownloadWindowsDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function DownloadWindowsDialog({ open, onClose }: DownloadWindowsDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="paper">
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 1 }}>
          <DownloadIcon color="primary" />
          <Typography component="span" variant="h6">
            Download TimeSentinel for Windows
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Optional desktop agent for Windows. You can use the web portal without installing this app.
        </Typography>
        <DownloadWindowsContent onDownloadStarted={onClose} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
